import { type JanusCtx, type Row, handBack, isInventoryRow, upper } from './context.js';
import { type TriggerEvent } from '../reactions/trigger-dispatch.js';
import { REDUCE_DAMAGE_ROLL } from './rolls/reduce-damage-status.js';
import { runTriggerFamily, triggerFamilyPreDraw } from './trigger-executor.js';
import { POST_ROLL_EXCLUDED_LAYERS } from './post-roll-reaction-shape.js';

/** damage_roll.php's two defender passes; the pre-roll against-roll and reflection carriers own their separate pass. */
export function postRollReactionEvent(rollType: string, reduce: boolean, hit: boolean): TriggerEvent {
  return { trigger: 'triggers_on_roll_type_against_the_caster', rollType: upper(rollType), hit,
    ...(reduce ? { restrictToAbilityRollTypes: [REDUCE_DAMAGE_ROLL] } : {
      excludeAbilityRollTypes: [REDUCE_DAMAGE_ROLL],
      excludeAbilitiesWithLayer: POST_ROLL_EXCLUDED_LAYERS,
    }) };
}

export function postRollReactionEvents(rollType: string): TriggerEvent[] {
  return [postRollReactionEvent(rollType, true, true), postRollReactionEvent(rollType, false, true), postRollReactionEvent(rollType, false, false)];
}

/** Preview both possible outcomes for every possible recipient before the inciting d20. Consent stays in the shared executor. */
export function postRollReactionsPreDraw(ctx: JanusCtx, attacker: Row, defender: Row, rollType: string): void {
  if (ctx.trigger || isInventoryRow(defender)) return;
  if (!ctx.read.reactionInventoryComplete(defender)) handBack('attack_roll:reaction-inventory-incomplete');
  for (const event of postRollReactionEvents(rollType))
    triggerFamilyPreDraw(ctx, defender, event, undefined, attacker);
}

export function runPostRollReduce(ctx: JanusCtx, attacker: Row, defender: Row, rollType: string): void {
  if (!ctx.trigger && !isInventoryRow(defender))
    runTriggerFamily(ctx, postRollReactionEvent(rollType, true, true), defender, attacker, [attacker], false);
}

export function runPostRollRetaliation(ctx: JanusCtx, attacker: Row, defender: Row, rollType: string, hit: boolean): void {
  if (!ctx.trigger && !isInventoryRow(defender))
    runTriggerFamily(ctx, postRollReactionEvent(rollType, false, hit), defender, attacker, [attacker], false);
}
